import { Button, Radio, Typography } from 'antd';
import React, { useState, useEffect, useMemo } from 'react'
import { useClaimContext } from '../../component/claim-context';
import LilyButton from '../../../../../components/button/lily-button';
import CardIcon from '../../../../../assets/card.svg';
import PaperCheckIcon from '../../../../../assets/paper-check.svg';
import CheckByMail from './check-by-mail';
import DirectDeposit from './direct-deposit';
import { useSelector } from 'react-redux';
import { getDefaultMethodDescription, getDefaultMethodObject } from '../../../../../exports/util';

const ReimbursementMethod = () => {
    const { Title, Text } = Typography;
    const user = useSelector((state) => state.authenticatedUser);
    // const [optionValue, setOptionValue] = useState('');
    const [optionMethod, setOptionMethod] = useState('');
    const [displayMethod, setDisplayMethod] = useState('');
    const { claimForm, setClaimForm, setCurrent } = useClaimContext();
    const [hasSavedPayment, setHasSavedPayment] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState('');
    const [entityPayment, setEntityPayment] = useState(null);
    const [existedMethodText, setExistedMethodText] = useState(null);

    useEffect(() => {
        if (!user) return;
        let hasExistedPayment = false;
        if (user?.reimbursementMethods?.length > 0) {
            hasExistedPayment = true;
            setEntityPayment(user?.reimbursementMethods);
            setExistedMethodText(getDefaultMethodDescription(user?.reimbursementMethods));
        }
        setHasSavedPayment(hasExistedPayment);
        setOptionMethod(claimForm?.paymentInfo?.method || '');


        setSelectedMethod(claimForm?.paymentInfo?.method || '');
    }, [user, claimForm]);

    const handleNext = () => {
        setDisplayMethod(selectedMethod);
    }

    const disabledButton = useMemo(() => {
        if (selectedMethod) {
            return false
        }

        return true
    }, [optionMethod, hasSavedPayment, selectedMethod]);

    const renderPaymentMethod = () => {
        return (
            <div className='row g-3'>
                <div className='col-md-6 col-12'>
                    <div className={`select-card-layout ${selectedMethod === 'direct-deposit' && 'selected'}`} onClick={() => setSelectedMethod('direct-deposit')}>
                        <div className='d-flex flex-row align-items-start gap-3'>
                            <img src={CardIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                            <div className='d-flex flex-column'>
                                <Text style={{ fontWeight: '500' }}>Direct Deposit (ACH)</Text>
                                <Text>
                                    Connect your bank account and receive your payment within 3–5 business days.
                                </Text>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 col-12'>
                    <div className={`select-card-layout ${selectedMethod === 'check-by-mail' && 'selected'}`} onClick={() => setSelectedMethod('check-by-mail')}>
                        <div className='d-flex flex-row align-items-start gap-3'>
                            <img src={PaperCheckIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                            <div className='d-flex flex-column'>
                                <Text style={{ fontWeight: '500' }}>Check by Mail</Text>
                                <Text>
                                    Checks will be sent within 15 days.
                                </Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            {(() => {
                switch (displayMethod) {
                    case 'direct-deposit':
                        return <DirectDeposit setDisplayMethod={setDisplayMethod} />
                    case 'check-by-mail':
                        return <CheckByMail isSetting={false} setDisplayMethod={setDisplayMethod} />
                    default:
                        return (
                            <div>
                                <div className='d-flex flex-column gap-4'>
                                    <div className='d-flex flex-column gap-2'>
                                        <Title className='mb-1 main-title' level={3}>
                                            Reimbursement Method
                                        </Title>
                                        <Text>Choose how you would like to receive your reimbursement</Text>
                                    </div>
                                    {
                                        renderPaymentMethod()
                                    }
                                </div>
                                <div className='d-flex flex-row justify-content-end mt-5'>
                                    <Button
                                        style={{ width: '200px' }}
                                        color="default"
                                        variant="link"
                                        onClick={() => setCurrent(1)}
                                    >
                                        Back
                                    </Button>
                                    <LilyButton style={{ width: '200px' }} disabled={disabledButton} onClick={handleNext} text="Next" />
                                </div>
                            </div>
                        )
                }
            })()}
        </div>
    )
}

export default ReimbursementMethod